(function($){

	var bestSlots = new Swiper('.js-best-slots', {
    spaceBetween: 0,
    slidesPerView: 1,
    freeMode: false,
    navigation: {
      nextEl: '.best-slots-button-next',
      prevEl: '.best-slots-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        bulletElement: 'button',
        clickable: true
      },
  });

  var bestSlots = new Swiper('.js-slots-box', {
    freeMode: false,
    autoHeight: false,
    slidesPerView: 1,
    spaceBetween: 20, 
    navigation: {
      nextEl: '.slots-button-next',
      prevEl: '.slots-button-prev',
    },
    pagination: {
        el: '.swiper-pagination-slots',
        bulletElement: 'button',
        clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1220: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    }
  });

  var gamesSection = new Swiper('.js-games-box', {
    freeMode: false,
    slidesPerView: 2,
    slidesPerColumn: 2,
    spaceBetween: 20,
    navigation: {
      nextEl: '.games-button-next',
      prevEl: '.games-button-prev',
    },
    pagination: {
        el: '.swiper-pagination-games',
        bulletElement: 'button',
        clickable: true
    },
    breakpoints: {
      600: {
        slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 4,
        slidesPerColumn: 2,
        spaceBetween: 20,
      },
      1220: {
        slidesPerView: 5,
        slidesPerColumn: 2,
        spaceBetween: 20,
      },
    }
  });

  var gallerySlots = new Swiper('.js-slot-gallery', {
    // freeMode: false,
    // autoHeight:true,
    slidesPerView: 2,
    slidesPerColumn: 3,
    spaceBetween: 17, 
    pagination: {
        el: '.swiper-pagination-slots-gallery',
        bulletElement: 'button',
        clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerColumn: 3,
        spaceBetween: 22, 
      }
    }
  });
})(jQuery);